/**
 * Handles error responses and throws an error with detailed message.
 * @param response - API response object
 */
export const handleError = (response: any) => {
    const { status, data } = response;
  
    // Handle known errors and throw an appropriate message
    if (status === 401) {
      throw new Error(`Unauthorized: ${data.detail?.msg || 'Invalid API key.'}`);
    }else if (status === 400) {
      throw new Error(`Bad Request: ${data.detail?.msg || 'You may have sent an incorrect or missing value.'}`);
    } else if (status === 403) {
      throw new Error('Forbidden: Access is denied.');
    } else if (status === 500) {
      throw new Error('Server error: Please try again later.');
    } else if (status === 404) {
      throw new Error('Not Found: The requested resource could not be found.');
    } else {
      throw new Error(`Unexpected error: ${data.detail?.msg || 'An unknown error occurred.'}`);
    }
  };